module.exports = __webpack_public_path__ + "img/tuto_mobile_way_02_05.108d71a5.png";